<template>
  <div class="footer-container">
    <div class="footerbox">
      <div class="top">
        <div class="topTitle">
          <div class="blockitembox" v-for="(item, index) in baseData" :key="index">
            <p>{{ item.name }}</p>
            <ul>
              <li v-for="(itemdata, i) in item.children" :key="i" class="hoverstyle">
                <span @click="$router.push(itemdata.link)">{{ itemdata.name }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <div><span class="title">全倾</span></div>
          <ul>
            <li>
              <a href="https://beian.miit.gov.cn/">京ICP备2020037621号-1</a>
            </li>
            <li>
              <a href="https://beian.miit.gov.cn/">京ICP备2020037621号-2</a>
            </li>
            <li>京B2-20212258</li>
            <li>北京市朝阳区建国门赛特大厦</li>
            <li>contact@quanqing.com</li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <div>友情链接：</div>
        <ul>
          <li v-for="(item, i) in goodPartner" :key="i" @click="openNewPage(item.link)" class="hoverstyle">
            <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonFooter',
  data() {
    return {
      baseData: Object.freeze([
        {
          name: '承接项目',
          link: '',
          children: [
            {name: '网站建设', link: '/company?develop_id=1'},
            {name: 'APP开发', link: '/company?develop_id=2'},
            {name: '小程序开发', link: '/company?develop_id=3'},
            {name: '软件开发', link: '/company?develop_id=4'}
          ]
        },
        {
          name: '技术标准',
          link: '',
          children: [
            {name: '性能标准', link: '/quanqingStandard?classId=10'},
            {name: '安全标准', link: '/quanqingStandard?classId=6'},
            {name: 'java标准', link: '/quanqingStandard?classId=4'},
            {name: 'android标准', link: '/quanqingStandard?classId=17'}
          ]
        },
        {
          name: '知识视频',
          // link: '',
          children: [
            {name: '产品经理', link: '/techVideo?occupation=2'},
            {name: '视觉设计师', link: '/techVideo?occupation=4'},
            {name: 'java工程师', link: '/techVideo?occupation=8'},
            {name: 'php工程师', link: '/techVideo?occupation=9'}
          ]
        },
        {
          name: '入驻',
          link: '',
          children: [
            {name: '技术公司', link: '/enter?selectType=1'},
            {name: '兼职员工', link: '/enter?selectType=3'},
            {name: '兼职团队', link: '/enter?selectType=2'}
          ]
        },
        {
          name: '合作分佣',
          link: '',
          children: [
            {name: '代销', link: '/marketingCenter?type=1'},
            {name: '分享', link: '/marketingCenter?type=2'},
            {name: '导流', link: '/marketingCenter?type=3'},
            {name: '推广', link: '/marketingCenter?type=4'},
            {name: '引荐', link: '/marketingCenter?type=5'},
          ]
        },
        {
          name: '关于',
          link: '',
          children: [
            {name: '全倾介绍', link: '/quanqingAbout'},
            {name: '联系全倾', link: '/connectionQuanqing'}
          ]
        }
      ]),
      goodPartner: Object.freeze([
        {
          name: '腾讯云',
          link: 'https://cloud.tencent.com'
        },
        {
          name: '阿里云',
          link: 'https://www.aliyun.com'
        },
        {
          name: '公司宝',
          link: 'https://www.gongsibao.com'
        }
      ])
    }
  },
  methods: {
    openNewPage(url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  width: 100%;
  height: 328px;
  background: #ffffff;
  overflow: hidden;
}
.footerbox {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 45px;

  .top {
    width: 100%;
    display: flex;

    .topTitle {
      display: flex;
      font-size: 16px;
      flex: 1;
      .blockitembox {
        flex: 1;
        margin-right: 30px;
      }
      p {
        font-weight: bold;
        margin-bottom: 15px;
        color: #333333;
        margin-bottom: 15px;
      }
      ul > li {
        height: 30px;
        line-height: 30px;
        cursor: pointer;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .right {
    text-align: right;
    width: 350px;
    .title {
      margin-left: auto;
      display: block;
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: #5ad3cd;
      border-radius: 2px;
      color: #ffffff;
    }
    ul {
      margin-top: 20px;
    }
    ul > li {
      height: 25px;
      line-height: 25px;
      color: #999999;
      line-height: 22px;
    }
    ul > li > a {
      height: 25px;
      line-height: 25px;
      color: #999999;
      line-height: 22px;
    }
  }
  .bottom {
    display: flex;
    color: #999999;
    margin-top: 60px;
    div {
      flex: 1;
    }
    ul {
      width: 1100px;
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 50px;
        cursor: pointer;
      }
    }
  }
}
</style>
